import { baseApi } from '../../../shared/api/baseApi';
import type { FaqListDto } from '../model/dto';
import { toFaqBody, toFaqList } from '../model/mappers';
import type { FaqForm, FaqItem } from '../model/types';

/** Префикс /api обязателен: baseUrl в baseApi равен '/'. */
const ENDPOINT = '/api/admin/faq';

/** Тег 'FAQ' уже используется в старом проекте — держим то же имя. */
const TAG = 'FAQ' as const;

export const faqApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getFaqs: build.query<FaqItem[], void>({
            query: () => ENDPOINT,
            transformResponse: (response: FaqListDto) => toFaqList(response),
            providesTags: [{ type: TAG, id: 'LIST' }],
        }),

        createFaq: build.mutation<unknown, FaqForm>({
            query: (form) => ({ url: ENDPOINT, method: 'POST', body: toFaqBody(form) }),
            invalidatesTags: [{ type: TAG, id: 'LIST' }],
        }),

        updateFaq: build.mutation<unknown, { id: string; form: FaqForm }>({
            query: ({ id, form }) => ({ url: `${ENDPOINT}/${id}`, method: 'PATCH', body: toFaqBody(form) }),
            invalidatesTags: [{ type: TAG, id: 'LIST' }],
        }),

        deleteFaq: build.mutation<unknown, string>({
            query: (id) => ({ url: `${ENDPOINT}/${id}`, method: 'DELETE' }),
            invalidatesTags: [{ type: TAG, id: 'LIST' }],
        }),
    }),
    overrideExisting: false,
});

export const { useGetFaqsQuery, useCreateFaqMutation, useUpdateFaqMutation, useDeleteFaqMutation } = faqApi;